'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PreloadedStateHelper = require('./PreloadedStateHelper');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiffusionFeedHelper = function () {
    function DiffusionFeedHelper() {
        _classCallCheck(this, DiffusionFeedHelper);

        this.bookmakerFeedConfig = [{ bookmaker: 'PPWR', feed: 'PADDYPOWER' }, { bookmaker: 'BETFAIR', feed: 'BETFAIR' }, { bookmaker: 'WH_OXI', feed: 'WH_OXI' }, { bookmaker: 'LADB', feed: 'LADB' }, { bookmaker: 'BET365', feed: 'BET365' }, { bookmaker: 'CORAL', feed: 'CORAL' }, { bookmaker: 'BOLEYSPORTS', feed: 'BOLEYSPORTS' }, { bookmaker: 'RB', feed: 'RB' }, { bookmaker: _PreloadedStateHelper.skybetDiffusionName, feed: _PreloadedStateHelper.skybetDiffusionName }, { bookmaker: 'VC', feed: 'VC' }, { bookmaker: 'TOTE', feed: 'TOTE' }, { bookmaker: 'BETFRED', feed: 'BETFRED' }];
    }

    _createClass(DiffusionFeedHelper, [{
        key: 'getFeedByBookmaker',
        value: function getFeedByBookmaker(bookmaker) {
            var found = this.bookmakerFeedConfig.find(function (item) {
                return item.bookmaker === bookmaker;
            });
            return found ? found.feed : bookmaker;
        }
    }, {
        key: 'getBookmakerByFeed',
        value: function getBookmakerByFeed(feed) {
            var found = this.bookmakerFeedConfig.find(function (item) {
                return item.feed === feed;
            });
            return found ? found.bookmaker : feed;
        }
    }]);

    return DiffusionFeedHelper;
}();

exports.default = new DiffusionFeedHelper();


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/DiffusionFeedHelper.js
// module id = 1988
// module chunks = 1